export default "__VITE_PUBLIC_ASSET__897564f0__"